import { render, staticRenderFns } from "./PageWrap.vue?vue&type=template&id=a509c556&"
var script = {}
import style0 from "./PageWrap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports